import { useEffect, useRef, useState } from "react";
import { JitsiMeeting } from "@jitsi/react-sdk";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActivePanel, setApiRef, setChatIndication, setIsMeetJoined, setJitsiHostId, setParticipantJoin, setParticipantLeft } from "../redux/slices/JitsiMeetSlice";
import { useAppSelector } from "../redux/app/hooks";
import Loader from "../components/Loader/Loader";
import WarningPopup from "../components/WarningPopup/WarningPopup";
import { STUDENT_ROLE, TEACHER_ROLE, SCHOOL_ADMIN, PTA_ROLE, BOT, ALERT_MESSAGE_TWO_USERS, END_MEETING, FETCH_POLICY_NO_CACHE } from "../utils/constants";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ADD_PARTICIPANT_MEETING, DELETE_PARTICIPANT_MEETING, UPDATE_MEETING_PARTICIPANT_COUNT, UPDATE_MEETING_STATUS } from "../pages/AdminPta/api/PtaQuery";
import { END_THE_LIVE_SESSION, GET_SESSTION_BY_ID, UPDATE_SESSION_PARTICIPANTS_COUNT, UPDATE_SESSION_STATUS } from "../pages/LiveClass/api/LiveClassQuery";
import { ADD_PARTICIPANT_WORKSHOP, DELETE_PARTICIPANT_WORKSHOP, UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT, UPDATE_WORKSHOP_ENDED, UPDATE_WORKSHOP_MEETING_ID } from "../pages/Workshop/api/WorkshopQuery";
import moment from "moment";
import { CustomIJitsiMeetExternalApi, RecoringType, getConfigOverwrite } from "./JitsiHelper";
import ToasterWithMessage from "../components/toaster";
import { ADD_SESSION_PARTICIPANTS, DELETE_SESSION_PARTICIPANT, UPDATE_SESSION_RECORD } from "../Chime/helpers/Api/ChimeApi";
import { setCurrentSessionRecordingDetail } from "../redux/slices/dashboardSlice";
import axios from "axios";
import ConfirmationPopup from "../components/ConfirmationPopup/ConfirmationPopup";
import images from "../assets/images";
import { trackButtonClick } from "../firebase/analyticsHelper";
import { ButtonClickEvents } from "../firebase/constants/events";
import { captureEvent, updateUserProperties } from "../utils/PostHogHelper";
import { useChimeMeeting } from "../Chime/ChimeMeetingContext";
import { hasUserAlreadyJoined } from "../utils/helper";

export const JitsiConferenceCustomUI = () => {

    const [meetingState, setMeetingState] = useState<any>(null);
    const [openWarningPopup, setOpenWarningPopup] = useState<boolean>(false);
    const [apiLoading, setApiLoading] = useState<boolean>(true);
    const localUserIdRef = useRef<string | null>(null);
    // const { state } = useLocation();
    // const { meetingId, userName, isHost, isCreateMeeting, hostId, userId, avatarUrl, meetComponent, jitsiUrls } = state ?? {};
    // const meetingState = JSON.parse(localStorage.getItem("meetingState") || "{}");
    const jitsiServerURL = meetingState?.jitsiUrls?.jitsiMeetUrl;
    const recordingServerURL = `https://${meetingState?.jitsiUrls?.jitsiBotUrl}`;
    const { selectedClassRoomId, role, loginpage, jitsiRecordingService } = useAppSelector((state) => state?.auth);
    const { currentSessionId, currentWorkshopId, currentPtaMeetId, currentSessionDetail, meetComponent, currentUserId } = useAppSelector((state) => state?.dashboard);
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const timeUntilFinalCallRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const timeUntilToastRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const apiRef = useRef<any>(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = { email: meetingState?.hostId, displayName: `${meetingState?.isHost ? meetingState?.userName + "-" + meetingState?.hostId : meetingState?.userName }`, avatarURL: meetingState?.avatarUrl };
    const { error } = ToasterWithMessage();
    const [isRecording, setIsRecording] = useState<boolean>(false);
    localStorage.setItem("isMeetRecording", "false");
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const { Crying } = images;
    const [hasBotJoined, sethasBotJoined] = useState<boolean>(false);
    const [warningMessage, setWarningMessage] = useState<string>("");
    console.log("[Log] jitsiServerURL", { jitsiServerURL, recordingServerURL, jitsiRecordingService});

    // API's for updating the live class start status
    const [updateSessionStatus] = useMutation(UPDATE_SESSION_STATUS, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {},
      onError: (err) => {
        // error(err?.message);
        console.log("[Log] updateSessionStatus error", err?.message);
      }
    });
    
    // API's for updating the live class end status
    const [updateSessionEnd] = useMutation(END_THE_LIVE_SESSION, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updateSessionEnd error", err?.message);
        }
    });

    // API's for updating the live class participant count
    const [updateSessionParticipantCount] = useMutation(UPDATE_SESSION_PARTICIPANTS_COUNT, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updateSessionParticipantCount error", err?.message);
        }
    });

    // API's for updating the live class record start timer and recording status
    const [updateSessionRecord] = useMutation(UPDATE_SESSION_RECORD, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updateSessionRecord error", err?.message);
        }
    });

    // API to update Workshop staring status, recording status and recording timer
    const [updateWorkshopSession] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updateWorkshopSession error", err?.message);
        }
    });

    // API to update Workshop end status
    const [updateWorkshopEnd] = useMutation(UPDATE_WORKSHOP_ENDED, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updateWorkshopEnd error", err?.message);
        }
    });

    // API to update Workshop participant count
    const [updateWorkshopParticipantCount] = useMutation(UPDATE_SESSION_WORKSHOP_PARTICIPANT_COUNT, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updateWorkshopParticipantCount error", err?.message);
        }
    });

    // API to update PTA meeting status, recording timer and recording status
    const [updatePtaMeeting] = useMutation(UPDATE_MEETING_STATUS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updatePtaMeeting error", err?.message);
        }
    });

    // API to update PTA meeting participant count
    const [updatePtaParticipantCount] = useMutation(UPDATE_MEETING_PARTICIPANT_COUNT, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {},
        onError: (err) => {
            // error(err?.message);
            console.log("[Log] updatePtaParticipantCount error", err?.message);
        }
    });

    //adding participant to the workshop
    const [addParticipantWorkshop] = useMutation(ADD_PARTICIPANT_WORKSHOP, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
        console.log("Participant added successfully workshop:", data);
      },
      onError: (err) => {
        // error("Error adding participant");
        console.log("Error adding participant workshop:", err);
      },
    });

    const [deleteParticipantWorkshop] = useMutation(DELETE_PARTICIPANT_WORKSHOP, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        console.log("Participant deleted successfully workshop:", data);
    },
    onError: () => {
        // error("Error deleting participant");
        console.log("Error deleting participant");
    },
  });


  const [addParticipantPTAMeeting] = useMutation(ADD_PARTICIPANT_MEETING, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      console.log("Added:", data.addParticipantMeeting);
    },
    onError: (err) => {
        // error("Error adding participant");
        console.log("Error adding participant PTA meeting:", err);
    },
  });

  const [deleteParticipantPTAMeeting] = useMutation(
    DELETE_PARTICIPANT_MEETING,
    {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: (data) => {
        console.log("Deleted:", data.deleteParticipantMeeting);
      },
      onError: (err) => {
        // error("Error deleting participant");
        console.log("Error deleting participant:", err);
      },
    }
  );

  const [addSessionParticipant] = useMutation(ADD_SESSION_PARTICIPANTS, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: (data) => {
    console.log("Participant added successfully session:", data);
  },
  onError: (err) => {
    // error("Error adding participant:");
    console.log("Error adding participant session:", err);
  },
});

const [deleteSessionParticipant] = useMutation(DELETE_SESSION_PARTICIPANT, {
  fetchPolicy: FETCH_POLICY_NO_CACHE,
  onCompleted: (data) => {
    console.log("Participant deleted successfully:", data);
  },
  onError: (err) => {
    console.log(err)
    // error("Error deleting participant:");
  },
});


    const handleModerator = async (apiObj: CustomIJitsiMeetExternalApi) => {
        try {
            const roomsInfo = await apiObj.getRoomsInfo();
            const mainRoom = roomsInfo.rooms?.find((room: any) => room.isMainRoom);

            if (mainRoom) {
                const moderator = mainRoom.participants.find((participant: any) => participant.role === "moderator");
                const actualHost = mainRoom.participants.find((participant: any) => participant?.displayName?.includes(meetingState?.hostId));
                console.log("[Log] handleModerator", { roomsInfo, mainRoom, moderator, actualHost, currentUserId: apiObj?._myUserID });
                if (moderator?.id === apiObj?._myUserID && moderator?.id !== actualHost?.id) {
                    apiObj.executeCommand('grantModerator', actualHost?.id);
                }
            }
        } catch (error) {
            console.error("[Log] Error in handleModerator:", error);
        }
    };

    const pinModeratorOrLocalUser  = async (apiObj: CustomIJitsiMeetExternalApi, screenSharingIds: string[]) => {
        try {
            const roomsInfo = await apiObj.getRoomsInfo();
            const mainRoom = roomsInfo.rooms?.find((room: any) => room.isMainRoom);

            if (mainRoom) {
                const moderator = mainRoom.participants.find((participant: any) => participant.role === "moderator");
                console.log("[Log] pinModeratorOrLocalUser", { roomsInfo, mainRoom, moderator, localUserIdRef });
                dispatch(setJitsiHostId({ jitsiHostId: moderator?.id }));
                if (screenSharingIds?.length > 0) {
                    apiObj.executeCommand('setLargeVideoParticipant', screenSharingIds?.[screenSharingIds?.length - 1], 'desktop');
                } else if (moderator) {
                    apiObj.pinParticipant(moderator?.id);
                } else if (localUserIdRef.current) {
                    apiObj.pinParticipant(localUserIdRef?.current);
                }
            }
        } catch (error) {
            console.error("[Log] Error in pinModeratorOrLocalUser:", error);
        }
    };

    const customizeIFrame = (divRef: HTMLDivElement) => {
        const iframeRef = divRef.querySelector("iframe");
        if (iframeRef) {
        iframeRef.style.height = `100vh`;
        iframeRef.style.width = `100%`;
        iframeRef.style.overflow = `hidden`;
        }
    };

    const closeWarnPopup  = () => {
        setOpenWarningPopup(false);
        if (warningMessage === "Unable to join the meeting. Please try again.") {
            leaveMeeting(); 
            // navigatePaths();
        }
        setWarningMessage("");
    };

    const updateEndMeeting = async () => {
        console.log("[Log] updateEndMeeting called");
        if (meetingState?.meetComponent === "liveclass" && selectedSubjectId && currentSessionId && selectedClassRoomId) {
            await updateSessionEnd({
                variables: {
                cId: selectedClassRoomId,
                sId: currentSessionId,
                sjId: selectedSubjectId,
                },
            });
        } 
        else if (meetingState?.meetComponent === "workshop" && currentWorkshopId) {
            await updateWorkshopEnd({
                variables: {
                wsId: currentWorkshopId,
                },
            });
        } 
        else if (meetingState?.meetComponent === "pta" && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                updateInput: {
                    mStatus: "ENDED",
                },
                mId: currentPtaMeetId,
                },
            });
        } 
    }

    const handleLeaveOrEndMeetingClick = async (action: "hangup" | "end-meeting", apiObj: CustomIJitsiMeetExternalApi) => {

        console.log("[Log] handleLeaveOrEndMeetingClick", action);
        if ( (meetingState?.isHost && isRecording) || (action === END_MEETING && isRecording) ) {
            console.log("[Log] Stopping", { isRecording});
            handleStopRecording(apiObj);
        }
        if (action === END_MEETING) {
            updateEndMeeting();
            if (hasBotJoined && jitsiRecordingService === BOT) {
                setTimeout(() => {
                     removeRecordingBot();
                }, 20000)
            }
        }
        console.log("[Log] handleLeaveOrEndMeetingClick called", action, meetingState);
        trackButtonClick(action === END_MEETING ? ButtonClickEvents?.JITSI_END_MEETING_BUTTON_CLICK : ButtonClickEvents?.JITSI_LEAVE_MEETING_BUTTON_CLICK, {
            description: `User clicked the ${action === END_MEETING ? "End Meeting" : "Leave Meeting"} button`,
        });
        if(meetingState?.meetingId && meetingState?.userId){
              updateUserProperties({
                  meetingId: meetingState?. meetingId!, // overwrite old value
              });
              captureEvent(meetingState?.userId || '', {
                role: role,
                loginType: loginpage,
                meetingId: meetingState?.meetingId!
              });
        }

        console.log("[Log] Executing command", action === END_MEETING ? "endConference" : "hangup");
        apiObj.executeCommand(action === END_MEETING ? "endConference" : "hangup");
        dispatch(setIsMeetJoined({ isMeetjoined: false }));
        dispatch(setApiRef({ apiRef: null }));
        dispatch(setActivePanel({ activePanel: null }));
        localStorage.setItem("isJoined", "left");
        if(window?.electron && window?.electron?.isElectron()){
            setTimeout(() => {
                window?.electron?.leaveMeeting(meetingState);
            }, 3000);
        } else {
            setTimeout(() => {
                window.close();
            }, 1500);
        }
    };

    const leaveMeeting = () => {
        console.log("[logging]", window?.electron)
        localStorage.setItem("isJoined", "left");
        if(window?.electron && window?.electron?.isElectron()){
            setTimeout(() => {
                window?.electron?.leaveMeeting(meetingState);
            }, 3000);
        } else {
            setTimeout(() => {
                window.close();
            }, 1500);
        }
    };

    const navigatePaths = () => {
      if (role && meetingState?.meetComponent) {
        if (role === STUDENT_ROLE) {
          navigate("/student-classroom/liveclass", { state: meetingState });
        } else if (role === TEACHER_ROLE && meetingState?.meetComponent === "liveclass") {
          navigate("/teacher-classroom/liveclass", { state: meetingState });
        } else if (role === TEACHER_ROLE && meetingState?.meetComponent === "workshop") {
          navigate("/teacher-workshop");
        } else if (role === TEACHER_ROLE && meetingState?.meetComponent === "pta") {
          navigate("/teacher-pta", {
            state: meetingState,
          });
        } else if (role === SCHOOL_ADMIN && meetingState?.meetComponent === "pta") {
          navigate("/admin-pta/meetings", {
            state: meetingState,
          });
        } else if (role === SCHOOL_ADMIN && loginpage === SCHOOL_ADMIN && meetingState?.meetComponent === "workshop") {
          navigate("/admin-workshop");
        } else if (role === PTA_ROLE) {
          navigate("/pta-meetings", {
            state: meetingState,
          });
        }
      }
    };

    const handleUpdateParticipantCount = async (apiObj: CustomIJitsiMeetExternalApi, action?: string) => {
        const roomsInfo = await apiObj.getRoomsInfo();
        const mainRoom = roomsInfo.rooms?.find((room: any) => room.isMainRoom);
        const moderator = mainRoom.participants.find((participant: any) => participant.role === "moderator");
        console.log('[Log] main participants',mainRoom.participants,mainRoom.participants?.length, moderator);        
        console.log("[Log] participant count", { participantCount: apiObj?.getNumberOfParticipants() });

        if(mainRoom && (meetingState?.isHost || moderator?.id === apiObj?._myUserID)){
            if (meetingState?.meetComponent === "liveclass" && currentSessionId && selectedSubjectId && selectedClassRoomId) {
                await updateSessionParticipantCount({
                    variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                    participantCount: apiObj?.getNumberOfParticipants()
                    }
                });
            } 
            else if (meetingState?.meetComponent === "workshop" && currentWorkshopId) {
                await updateWorkshopParticipantCount({
                    variables: {
                        input: {
                            participantCount: apiObj?.getNumberOfParticipants(),
                            wsId: currentWorkshopId
                        }
                    }
                });
            } 
            else if (meetingState?.meetComponent === "pta" && currentPtaMeetId) {
                await updatePtaParticipantCount({
                    variables: {
                    input: {
                        mId: currentPtaMeetId,
                        participantCount: apiObj?.getNumberOfParticipants()
                    }
                    }
                });
            }
        }
    };

    const handleAddParticipant = async (
      apiObj: CustomIJitsiMeetExternalApi
    ) => {
      // To get info about the current user id
      const localParticipantId = apiObj._myUserID;
      const participantId = `${meetingState?.userId}|${localParticipantId}`;
      console.log(participantId, "[debug]participantId");
      localStorage.setItem("jitsiLocalParticipantId", participantId);

    //   if (meetComponent === "workshop" && currentWorkshopId) {
    //     // await addParticipantWorkshop({
    //     //   variables: {
    //     //     participantId: participantId,
    //     //     wsId: currentWorkshopId,
    //     //   },
    //     // });
    //   } else if (meetComponent === "pta" && currentPtaMeetId) {
    //     // await addParticipantPTAMeeting({
    //     //   variables: {
    //     //     mId: currentPtaMeetId,
    //     //     participantId: participantId,
    //     //   },
    //     // });
    //   }  
        if (
        meetingState?.meetComponent === "liveclass" &&
        currentSessionId &&
        selectedSubjectId &&
        selectedClassRoomId
      ) {
        addSessionParticipant({
          variables: {
            cId: selectedClassRoomId,
            sId: currentSessionId,
            sjId: selectedSubjectId,
            participantId: participantId,
          },
        });
      }
    };

    const handleDeleteParticipant = async (
      apiObj: CustomIJitsiMeetExternalApi
    ) => {
      // To get info about the current user id
      const localParticipantId = apiObj._myUserID;
      const participantId = `${meetingState?.userId}|${localParticipantId}`
      console.log(participantId, "[debug]participantId")

    //   if (meetComponent === "workshop") {
    //     // await deleteParticipantWorkshop({
    //     //   variables: {
    //     //     participantId: participantId,
    //     //     wsId: currentWorkshopId,
    //     //   },
    //     // });
    //   }
    //   else if (meetComponent === "pta" && currentPtaMeetId) {
    //     // await deleteParticipantPTAMeeting({
    //     //   variables: {
    //     //     mId: currentPtaMeetId,
    //     //     participantId: participantId,
    //     //   },
    //     // });
    //   }
     localStorage.setItem("jitsiLocalParticipantId", participantId);
     console.log("[Log] handleDeleteParticipant called", meetingState, currentSessionId, selectedSubjectId, selectedClassRoomId);
        if (
        meetingState?.meetComponent === "liveclass" &&
        currentSessionId &&
        selectedSubjectId &&
        selectedClassRoomId
      ) {
        deleteSessionParticipant({
          variables: {
            cId: selectedClassRoomId,
            sId: currentSessionId,
            sjId: selectedSubjectId,
            participantId: participantId,
          },
        });
      }
    };

    const [getSingleSession] = useLazyQuery(GET_SESSTION_BY_ID, {
      fetchPolicy: FETCH_POLICY_NO_CACHE,
      onCompleted: async (data) => {
        console.log("[Log] getSingleSession data", data);
      },
      onError: (err) => {
        console.log("[Log] getSingleSession error", err?.message);
      }
    });
    

    const restrictMoreThanTwoSameUsers = async (apiObj: CustomIJitsiMeetExternalApi) => {
        try {
            if(!selectedClassRoomId || !currentSessionId || !selectedSubjectId) {
                return;
            }

            const { data } = await getSingleSession({
                variables: {
                    input : {
                        cId: selectedClassRoomId,
                        sId: currentSessionId,
                        sjId: selectedSubjectId,
                    }
                }
            })
            const response = data?.getSession;
            if (!response) {
                return;
            }
        
            const alreadyJoined = hasUserAlreadyJoined(response.participantIds || [], currentUserId);
        
            if (alreadyJoined) {
              error(ALERT_MESSAGE_TWO_USERS)
              console.log("User already joined, blocking...");
              setTimeout(() => {
                apiObj.executeCommand('hangup');
                leaveMeeting();
              }, 2000);
            }

        } catch (error) {
            console.error("[Log] Error in restrictMoreThanTwoSameUsers:", error);
        }
    };

    const handleUpdateRecordTime = async (recordingStatus: boolean, recordStartTime: string) => {
        if (meetingState?.meetComponent === "liveclass" && selectedClassRoomId && currentSessionId && selectedSubjectId) {
            await updateSessionRecord({
                variables: {
                    cId: selectedClassRoomId,
                    sId: currentSessionId,
                    sjId: selectedSubjectId,
                    isRecordStart: recordingStatus,
                    recordStarttime: recordStartTime,
                },
            });
        } else if (meetingState?.meetComponent === "workshop" && currentWorkshopId) {
            await updateWorkshopSession({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime: recordStartTime,
                    },
                    wsId: currentWorkshopId,
                }
            });
        } else if (meetingState?.meetComponent === "pta" && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                    updateInput: {
                        isRecordStart: recordingStatus,
                        recordStartTime: recordStartTime,
                    },
                    mId: currentPtaMeetId,
                }
            });
        }
        dispatch(setCurrentSessionRecordingDetail({ recordingStartedTime: recordStartTime, recordingStarted: recordingStatus }));
    };

    const handleUpdateMeetingStatus = async () => {
        if (meetingState?.meetComponent === "liveclass" && selectedClassRoomId && selectedSubjectId && currentSessionId && meetingState?.meetingId && meetingState?.hostId) {
            await updateSessionStatus({
                variables: {
                    cId: selectedClassRoomId,
                    sjId: selectedSubjectId,
                    sId: currentSessionId,
                    sCode: meetingState?.meetingId,
                    hostId: meetingState?.hostId,
                }
            });
        } else if (meetingState?.meetComponent === "workshop" && meetingState?.meetingId && meetingState?.hostId && currentWorkshopId) {
            await updateWorkshopSession({
                variables: {
                    updateInput: {
                        wsCode: meetingState?.meetingId,
                        wsStatus: "STARTED",
                        hostId: meetingState?.hostId,
                    },
                    wsId: currentWorkshopId
                }
            });
        } else if (meetingState?.meetComponent === "pta" && meetingState?.meetingId && meetingState?.hostId && currentPtaMeetId) {
            await updatePtaMeeting({
                variables: {
                    updateInput: {
                        mCode: meetingState?.meetingId,
                        mStatus: "STARTED",
                        hostId: meetingState?.hostId,
                      },
                      mId: currentPtaMeetId,
                }
            });
        }
    };

    const checkEndTime = () => {
        console.log("[Log] check end time method");
        apiRef.current.executeCommand('endConference');
        handleDeleteParticipant(apiRef.current)
    };


    useEffect(() => {
        if(window?.electron && window?.electron?.isElectron()) {
            window.electron.onMeetingState((_event, data) => {
                console.log("[Log] Received Jitsi meeting state:", data);
                setMeetingState(data);
            });
        } else {
            const state = JSON.parse(localStorage.getItem("meetingState") || "{}");
            setMeetingState(state);
        }
        const accessTokenInterval = setInterval(async () => {
            const token = localStorage.getItem(
                Object.keys(localStorage).find((key) => key.includes('accessToken')) as string
            );
            // If token is missing => force leave meeting
            if (!token) {
                const state = JSON.parse(localStorage.getItem("meetingState") || "{}");
                console.log("[Log] meetingState from localStorage", state);
                const action: 'hangup' | 'end-meeting' = "hangup";
                if(meetComponent === 'liveclass' && role === TEACHER_ROLE){
                    // action = "end-meeting";
                    console.log("[Log] Leaving meeting as participant liveclass", role , meetComponent);
                    await handleLeaveOrEndMeetingClick(END_MEETING, apiRef.current);
                } else if(meetComponent === 'workshop' && role === SCHOOL_ADMIN){
                    // action = "end-meeting";
                    console.log("[Log] Leaving meeting as participant workshop", role , meetComponent);
                    await handleLeaveOrEndMeetingClick(END_MEETING, apiRef.current);
                } else if(meetComponent === 'pta' && role === SCHOOL_ADMIN){
                    // action = "end-meeting";
                    console.log("[Log] Leaving meeting as participant pta", role , meetComponent);
                    await handleLeaveOrEndMeetingClick(END_MEETING, apiRef.current);
                } else {
                    console.log("[Log] Leaving meeting as participant else", role , meetComponent);
                    await handleLeaveOrEndMeetingClick("hangup", apiRef.current);
                }
                // console.log("[Log] determined action:", action);
                // await handleLeaveOrEndMeetingClick(action, apiRef.current);
                clearInterval(accessTokenInterval);
            }

        }, 1000);   
        
        return () => {
            clearInterval(accessTokenInterval);
        }
    }, []);

    useEffect(() => {
    const handler = () => {
        localStorage.setItem("wayOfLeft", "invalid");
        localStorage.setItem("isJoined", "left");
    };

    window.addEventListener("beforeunload", handler);
    window.addEventListener("popstate", handler);

    return () => {
        window.removeEventListener("beforeunload", handler);
        window.removeEventListener("popstate", handler);
    };
    }, []);

    useEffect(() => {
        console.log("[Log] meetingStateValue changed:", meetingState);
    }, [meetingState]);

    useEffect(() => {

        console.log("[Log] inside auto useEffect");
        console.log("[Log] Electron", window.electron);
        
        if (window.electron) {
            window.electron.startScreenCapture();
        }

        // Parse start and end times
        const start = moment(currentSessionDetail.startDate);
        const end = moment(currentSessionDetail.endDate);
    
        // Calculate duration in minutes
        const duration = moment.duration(end.diff(start)).asMinutes();
    
        let adjustedEndTime;
    
        if (duration <= 5) {
            adjustedEndTime = end.clone().subtract(1, 'minute');
        } else {
            adjustedEndTime = end.clone().subtract(5, 'minutes');
        }
    
        // Calculate the times for the toaster and final method
        const currentTime = moment();
        const timeUntilToast = adjustedEndTime.diff(currentTime);
        const timeUntilFinalCall = end.clone().add(1, 'minute').diff(currentTime);
    
        // Set timeout for showing toaster
        if (timeUntilToast > 0) {
            timeUntilToastRef.current = setTimeout(() => {
            if((role === SCHOOL_ADMIN && meetingState?.meetComponent === 'workshop' && loginpage === SCHOOL_ADMIN) || (role === TEACHER_ROLE && meetingState?.meetComponent === 'liveclass')){
                setWarningMessage('The meeting will be automatically ended on scheduled time');
                setOpenWarningPopup(true);
            }
            }, timeUntilToast);
        }
    
        // Set timeout for calling the final method
        if (timeUntilFinalCall > 0) {
            timeUntilFinalCallRef.current = setTimeout(() => {
            console.log("[Log] inside timeout");
            checkEndTime();
            }, timeUntilFinalCall);
        }

        return () => {
            if(timeUntilToastRef.current){
                clearTimeout(timeUntilToastRef.current);
            }
            if(timeUntilFinalCallRef.current){
                clearTimeout(timeUntilFinalCallRef.current);
            }
        }
    }, [currentSessionDetail?.startDate, currentSessionDetail?.endDate, checkEndTime]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (apiLoading) {
                console.log("[Log jitsi] Jitsi failed to load. Navigating back...");
                setWarningMessage('Unable to join the meeting. Please try again.');
                setOpenWarningPopup(true);
            }
        }, 60000);
        if (!apiLoading) {
            console.log("[Log jitsi] Meeting loaded successfully");
            setOpenWarningPopup(false);
            setWarningMessage("");
        }
        console.log("[Log jitsi] timeoutId", timeoutId);

        return () => clearTimeout(timeoutId);
    }, [apiLoading]);

    const addRecordingBot = async () => {
        if (!apiRef.current) {
            console.error("[Log] Jitsi API not available");
            return;
        }

        try {
            const response = await axios.post(`${recordingServerURL}/joinMeet`, {
                meet_link: `https://${jitsiServerURL}/${meetingState?.meetingId}`,
                start_record: false,
            }, { timeout: 30000 });
            console.log("[Log Bot] Join meet response:", response);
            sethasBotJoined(true);
        } catch (err: any) {
            console.error("[Log Bot] Join meet error:", err);
            sethasBotJoined(false);
        }
    };

    const removeRecordingBot = async () => {
        try {
            const response = await axios.post(`${recordingServerURL}/stopMeet`, {
                meet_link: `https://${jitsiServerURL}/${meetingState?.meetingId}`
            }, { timeout: 30000 });
            console.log("[Log Bot] stop meet response:", response);
            sethasBotJoined(false);
        } catch (err: any) {
            console.error("[Log Bot] stop meet error:", err);
        }
    };

    const getBotRecordStatus = async () => {
        try {
            const response = await axios.post(`${recordingServerURL}/get/record/status`, {
                meet_link: `https://${jitsiServerURL}/${meetingState?.meetingId}`
            }, { timeout: 30000 });
            console.log("[Log Bot] Bot record status:", response);
            return response?.data?.status;
        } catch (err: any) {
            console.error("[Log Bot] Bot record status error:", err);
        }
    }

    const handleStartRecording = async (apiObj: CustomIJitsiMeetExternalApi) => {

        const newRecordingStartTime = new Date().toISOString();
        const recordingData = {
            type: "SET_RECORD_START_TIMER",
            recordStartTime: newRecordingStartTime,
            recordingStatus: true,
            jitsiRecordingService: jitsiRecordingService,
            isHost: meetingState?.isHost
        };

        if (jitsiRecordingService === BOT) {
            console.log("[Log Bot] Start recording clicked", { hasBotJoined });
            try {
                await getBotRecordStatus();
                const response = await axios.post(`${recordingServerURL}/startRecording`, {
                    meet_link: `https://${jitsiServerURL}/${meetingState?.meetingId}`,
                    start_record: true
                }, { timeout: 30000 });
                console.log("[Log Bot] Start recording response:", response);
                // apiObj.executeCommand("showNotification", {
                //     title: "custom-layout-action",
                //     description: recordingData
                // });
                // apiObj.executeCommand('sendEndpointTextMessage', '', recordingData);
                apiObj.executeCommand('sendChatMessage', JSON.stringify({ "TYPE": "RECORDING", "MESSAGE": recordingData}));
                handleUpdateRecordTime(true, newRecordingStartTime);
                localStorage.setItem("isMeetRecording", "true");
                setIsRecording(true);
            } catch (err: any) {
                console.log("[Log Bot] Start recording error:", err);
                localStorage.setItem("isMeetRecording", "false");
                setIsRecording(false);
            }
        }
        else {
            apiObj.startRecording({ 
                mode: "file",
                dropboxToken: "",
                shouldShare: false,
                rtmpStreamKey: "",
                rtmpBroadcastID: "",
                youtubeStreamKey: "",
                youtubeBroadcastID: "",
            });
            // apiObj.executeCommand("showNotification", {
            //     title: "custom-layout-action",
            //     description: recordingData
            // });
            // apiObj.executeCommand('sendEndpointTextMessage', '', recordingData);
            apiObj.executeCommand('sendChatMessage', JSON.stringify({ "TYPE": "RECORDING", "MESSAGE": recordingData}));
            handleUpdateRecordTime(true, newRecordingStartTime);
            localStorage.setItem("isMeetRecording", "true");
            setIsRecording(true);
        }
    };

    const handleStopRecording = async (apiObj: CustomIJitsiMeetExternalApi) => {
        const newRecordingStopTime = new Date().toISOString();
        const recordingData = {
            type: "SET_RECORD_START_TIMER",
            recordStartTime: null,
            recordingStatus: false,
            jitsiRecordingService: jitsiRecordingService,
            isHost: meetingState?.isHost
        };
        if (jitsiRecordingService === BOT) {
            console.log("[Log Bot] Stop recording clicked", { hasBotJoined });
            try {
                await getBotRecordStatus();
                const response = await axios.post(`${recordingServerURL}/stopRecording`, {
                    meet_link: `https://${jitsiServerURL}/${meetingState?.meetingId}`,
                }, { timeout: 30000 });
                console.log("[Log Bot] Stop recording response:", response);
                apiObj.executeCommand('sendChatMessage', JSON.stringify({ "TYPE": "RECORDING", "MESSAGE": recordingData}));
                // apiObj.executeCommand('sendEndpointTextMessage', '', recordingData);
                // apiObj.executeCommand("showNotification", {
                //     title: "custom-layout-action",
                //     description: recordingData,
                // });
                handleUpdateRecordTime(false, newRecordingStopTime);
                localStorage.setItem("isMeetRecording", "false");
                setIsRecording(false);
            } catch (err: any) {
                console.error("[Log Bot] Stop recording error:", err);
            }
        }
        else {
            apiObj.stopRecording("file");
            // apiObj.executeCommand("showNotification", {
            //     title: "custom-layout-action",
            //     description: recordingData
            // });
            // apiObj.executeCommand('sendEndpointTextMessage', '', recordingData);
            apiObj.executeCommand('sendChatMessage', JSON.stringify({ "TYPE": "RECORDING", "MESSAGE": recordingData}));
            handleUpdateRecordTime(false, newRecordingStopTime);
            localStorage.setItem("isMeetRecording", "false");
            setIsRecording(false);
        }
    };



    const handleApiReady = (apiObj: CustomIJitsiMeetExternalApi) => {
        if (apiObj) {
            dispatch(setApiRef({ apiRef: apiObj }));
            apiRef.current = apiObj;
        }
        console.log("[Log] getConfigOverwrite", getConfigOverwrite(meetingState?.isHost));
        
        let screenSharingIds: string[] = [];

        apiObj.on("contentSharingParticipantsChanged", (res) => {
            console.log("[Log] getContentSharingParticipants", res);
            pinModeratorOrLocalUser(apiObj, res?.data);
            screenSharingIds = res?.data;
        });

        apiObj.on("recordingStatusChanged", (val: RecoringType) => {
            console.log("[Log] recordingStatusChanged", val);
        });

        apiObj.on("videoConferenceJoined", async () => {
            const wayOfLeft = localStorage.getItem("wayOfLeft");
            const isManualLeft = localStorage.getItem("isManualLeft");
            
            // console.log("[Log] videoConferenceJoined", { isCreateMeeting, isHost });
            if(meetComponent === 'liveclass' && !(wayOfLeft && wayOfLeft === 'invalid' && isManualLeft !== 'yes')){
                await restrictMoreThanTwoSameUsers(apiObj);
            }
            setApiLoading(false);
            localStorage.removeItem("isManualLeft");
            localStorage.removeItem("wayOfLeft");
            dispatch(setIsMeetJoined({ isMeetjoined: true }));
            localStorage.setItem("isJoined", "joined");
            if (meetingState?.isHost && meetingState?.isCreateMeeting) {
                if ( jitsiRecordingService === BOT) {
                    addRecordingBot();
                }
                handleUpdateMeetingStatus();
            }
            pinModeratorOrLocalUser(apiObj, screenSharingIds);
            handleUpdateParticipantCount(apiObj);
            handleAddParticipant(apiObj)
            dispatch(setParticipantJoin({ participantJoin: true  }));
            // apiRef.current.executeCommand("showNotification", {
            //     title: "custom-layout-action",
            //     description: JSON.stringify({
            //         type: "SET_RECORD_START_TIMER",
            //         recordStartTime: currentSessionRecordingDetail?.recordingStartedTime,
            //         recordingStatus: currentSessionRecordingDetail?.recordingStarted,
            //         jitsiRecordingService: jitsiRecordingService,
            //         isHost
            //     }),
            // });
        });

        apiObj.on("videoConferenceLeft", async() => {
            console.log("[Log] videoConferenceLeft");
            await handleUpdateParticipantCount(apiObj,"videoConferenceLeft");
            await handleLeaveOrEndMeetingClick("hangup", apiObj);
            await handleDeleteParticipant(apiObj)
            localStorage.setItem('isJoined', "left");
            dispatch(setParticipantLeft({ participantLeft: true  }));
        });

        apiObj.on("toolbarButtonClicked", (object) => {
            console.log("[Log] toolbarButtonClicked", object);
            if (object.key === END_MEETING && meetingState?.isHost) {
                setOpenConfirmationPopup(true);
            }
            else if (object.key === 'hangup-menu') {
                setOpenConfirmationPopup(true);
            }
            else if (object.key === 'hangup') {
                setOpenConfirmationPopup(true);
                // handleUpdateParticipantCount(apiObj,"videoConferenceLeft");
                // handleLeaveOrEndMeetingClick(object.key, apiObj);
            }
            else if (object.key === 'start-recording' && meetingState?.isHost) {
                handleStartRecording(apiObj);
            }
            else if (object.key === 'stop-recording' && meetingState?.isHost) {
                handleStopRecording(apiObj);
            }
            else if (object.key === 'mute-all' && meetingState?.isHost) {
                apiObj.executeCommand('muteEveryone', 'audio');
            }
        });

        apiObj.on('_requestDesktopSources', async (request, callback) => {
            const { options } = request;
            window.electron.getDesktopSources(options)
                .then((sources:any) => callback({ sources }))
                .catch((error:any) => callback({ error }));
        });

        apiObj.on("chatUpdated", (data) => {
            console.log("[Log] chatUpdated", data);
            dispatch(setActivePanel({ activePanel: data?.isOpen ? "chat" : null }));
            if (data?.isOpen === false && data?.unreadCount > 0) {
                dispatch(setChatIndication({ chatIndication: true }));
            }
            else {
                dispatch(setChatIndication({ chatIndication: false }));
            }
        });

        apiObj?.executeCommand("showNotification", {
            title: "custom-layout-action",
            description: JSON.stringify({
                type: "SET_FILMSTRIP_POSITION",
                filmStripPosition: "top"
            })
        });

        apiObj?.executeCommand("showNotification", {
            title: "custom-layout-action",
            description: JSON.stringify({
                type: "SET_SCREENSHARE_FILMSTRIP_POSITION",
                screenShareFilmStripPosition: "bottom"
            })
        });

        apiObj.on("participantJoined", () => {
            console.log("[Log] participantJoined", apiObj);
            // pinModeratorOrLocalUser(apiObj, screenSharingIds);
            handleModerator(apiObj);
            handleUpdateParticipantCount(apiObj);
            dispatch(setParticipantJoin({ participantJoin: true  }));
        });

        apiObj.on("participantLeft", () => {
            console.log("[Log] participantLeft", apiObj);
            handleModerator(apiObj);
            handleUpdateParticipantCount(apiObj);
            dispatch(setParticipantLeft({ participantLeft: true  }));
        });

        apiObj.on("participantRoleChanged", (val: any) => {
            console.log("[Log] participantRoleChanged", val);
            apiObj.executeCommand('displayName', meetingState?.userName );
            pinModeratorOrLocalUser(apiObj, screenSharingIds);
        });

        apiObj.on("tileViewChanged", async (data) => {
            console.log("[Log] tileViewChanged", data);
            dispatch(setActivePanel({ activePanel: data?.enabled ? "tileView" : null }));
            // if (!data?.enabled) {
            //     await pinModeratorOrLocalUser(apiObj, screenSharingIds);
            //     dispatch(setActivePanel({ activePanel: null }));
            // }
            // else {
            //     dispatch(setActivePanel({ activePanel: "tileView" }));
            // }
        });

        apiObj.on("participantsPaneToggled", (data) => {
            console.log("[Log] participantsPaneToggled", data);
            dispatch(setActivePanel({ activePanel: data?.open ? "participants" : null }));
        });

        apiObj.on("endpointTextMessageReceived", (data) => {
            console.log("[Log] endpointTextMessageReceived", data, JSON.parse(data?.data?.eventData?.text));
            // apiObj.executeCommand("showNotification", {
            //     title: "custom-layout-action",
            //     description: data?.data?.eventData?.text
            // });
        });

    };

    const onYesButtonClick = async () => {
        setOpenConfirmationPopup(false);
        localStorage.setItem("isManualLeft", "yes");
        handleUpdateParticipantCount(apiRef.current,"videoConferenceLeft");
        handleLeaveOrEndMeetingClick(meetingState?.isHost ? END_MEETING : "hangup", apiRef.current);
    };

    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
    };

    return (
        <div className="jitsiMainContainer"  style={{ height: "100%" }}>
            {apiLoading && (!meetingState) && <Loader/>}
            {meetingState && <JitsiMeeting
                domain={jitsiServerURL}
                roomName={meetingState?.meetingId}
                configOverwrite={getConfigOverwrite(meetingState?.isHost)?.configOverwrite}
                interfaceConfigOverwrite={getConfigOverwrite(meetingState?.isHost)?.interfaceConfigOverwrite}
                onApiReady={(api) => handleApiReady(api as CustomIJitsiMeetExternalApi)}
                getIFrameRef={customizeIFrame}
                userInfo={userInfo}
                onReadyToClose={() => {
                    leaveMeeting(); 
                    // navigatePaths();
                }}
            />}
            <WarningPopup
                message={warningMessage}
                openWarningPopup={ openWarningPopup }
                closeWarnPopup={ closeWarnPopup }
            />
            <ConfirmationPopup
                open={openConfirmationPopup}
                message={`Are you sure you want to ${meetingState?.isHost ? "End" : "Leave"} this Session?`}
                gifData={Crying}
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={'264px'}
            />
        </div>
    );
};
